// Fetch interceptor to handle session expiration and unauthorized access
import { authenticationService } from '../services/authentication.service';

// Store original fetch
const originalFetch = window.fetch;

// Override global fetch
window.fetch = function(...args) {
    return originalFetch.apply(this, args)
        .then(async response => {
            // Check if response is 401 Unauthorized
            if (response.status === 401) {
                // Session expired or user not authenticated
                console.log('[Session] Unauthorized - redirecting to login');

                // Clear user data
                localStorage.removeItem('currentUser');

                // Show a notification to user
                const event = new CustomEvent('session-expired', {
                    detail: { message: 'Your session has expired. Please login again.' }
                });
                window.dispatchEvent(event);

                // Redirect to login after a short delay
                setTimeout(() => {
                    window.location.href = '/authentication/login';
                }, 1000);

                // Return rejected promise to stop further processing
                return Promise.reject({
                    status: 401,
                    message: 'Session expired'
                });
            }

            return response;
        })
        .catch(error => {
            // If it's our custom 401 error, rethrow it
            if (error.status === 401) {
                throw error;
            }

            // For other errors, check if it might be a network error indicating auth issues
            console.error('[Fetch Error]', error);
            throw error;
        });
};

export default window.fetch;
